/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'pip-media-manager'
], function(
    $,
    Mustache,
    pip,
    pipEvents,
    pipMediaManager
){

    var templates = {
        price: "{{{price}}}",
        thumbnail: "<img src=\"{{image}}\">"
    };

    var selectors = {
        price: '#sticky-nav__price',
        thumbnail: '#sticky-nav__thumbnail'
    }

    var defaultOffset;

    function display() {
        var scroll_top = $(window).scrollTop();
        if (scroll_top > defaultOffset) {
            $('#menuScroll').slideDown(300);
        } else {
            $('#menuScroll').hide();
        }
    }

    function getPricingMarkup() {
        var priceElement = $('.buybox__price #ajaxPriceAlt').length ? $('.buybox__price #ajaxPriceAlt') : $('.buybox__price #ajaxPrice');
        var unitOfMeasureElement = $(priceElement).next('#unitOfMeasure').length ? $(priceElement).next('#unitOfMeasure').clone(): $('.js-uom #unitOfMeasure').clone();
        return priceElement.clone(true).addClass("stickyAjaxPrice").append(unitOfMeasureElement);
    }

    function update() {
        defaultOffset = $('.buybox').offset().top + 400;
        var mediaData = pipMediaManager.getMedia();

        $(selectors.price).html(Mustache.render(templates.price, {price: pip.products.primary.data.itemExtension.isMapPriceScenario ? '' : getPricingMarkup().html()}));
        $(selectors.thumbnail).html(Mustache.render(templates.thumbnail, {image: mediaData.url_65}));

        updateBVRatingsHTML('#sticky_ratings_reviews');
        $('#menuScroll').find('.pricingStrikeThru').remove();
        display();
    }

    function updateBVRatingsHTML(selector) {
        var reviews = pip.products.primary.data.ratingsReviews;
        var template = '\
			<div class="ratings dynamic_ratings">\
				<a class="reviews" href="{{canonicalURL}}#customer_reviews">\
					<span class="stars" rel="{{reviews.rating}}">{{reviews.rating}}</span>\
				</a>\
				<a class="productReviews" href="{{canonicalURL}}#customer_reviews">({{reviews.total}})</a>\
			</div>';

        var html = Mustache.to_html(template, {
            canonicalUrl: pip.products.primary.data.canonicalUrl,
            reviews: {
                rating: reviews.rating || reviews.averageRating,
                total: reviews.totalReviews
            }
        });

        $(selector).html(html);

        var starsElement = $('.dynamic_ratings .stars');

        starsElement.each(function() {
            var rating = $(this).attr('rel');
            if (!$.isNumeric(rating)) rating = 0;
            $(this).css('width', (rating * 20) + '%');
        });

    }

    function updateNavLinksOnScroll(evtType) {
        var scrollPos = $(document).scrollTop();
        $('.sticky-nav__jump-links li a').each(function () {
            var currLink = $(this);
            var refElement = $(currLink.attr("href"));
            currLink.parent().removeClass("active");
            if ((refElement.position().top <= scrollPos) && (refElement.position().top + refElement.height() > scrollPos)) {
                currLink.parent().addClass("active");
            }
        });
    }

    return {

        init: function init() {
            pipEvents.media.mediaLoaded.off('.stickynav');
            pipEvents.media.mediaLoaded.on('.stickynav', update);
            $(window)
                .off('.stickynav')
                .on('scroll.stickynav resize.stickynav', display);

            $(document).off('.stickyJumpLinks').on('click.stickyJumpLinks', '.sticky-nav__jump-links ul li a', function(e) {
                $(window).off("scroll.stickyNav-scrollingLinks");
                e.preventDefault();
                $('.sticky-nav__jump-links ul li').removeClass('active');
                $(this).closest('li').addClass('active');
            });

            $(window).on('scroll.stickyNav-scrollingLinks', updateNavLinksOnScroll);

            pipEvents.scroll.scrollAnimationComplete.off('scrollAnimationComplete')
            pipEvents.scroll.scrollAnimationComplete.on('scrollAnimationComplete', function () {
                $(window).on('scroll.stickyNav-scrollingLinks', updateNavLinksOnScroll);
            });

        },

        updateRatingsReviews: function updateRatingsReviews(){
            updateBVRatingsHTML('#sticky_ratings_reviews');
        },

    }
});

}.call(window));